import React, { useState } from "react";
import { videoAPI, favoriteAPI } from "../services/api";
import api from "../services/api";

function fmt(n) {
  n = Number(n) || 0;

  if (n >= 1e6) return (n / 1e6).toFixed(1) + "M";

  if (n >= 1000) return (n / 1000).toFixed(1) + "K";

  return String(n);
}

function ActionButtons({
  video,
  likes,
  isLiked,
  onLike,
  onComment,
  commentCount,
}) {
  const [isSaved, setIsSaved] = useState(false);

  const [isShared, setIsShared] = useState(false);

  const wrapper = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
  };

  const buttonStyle = {
    width: 40,
    height: 40,
    borderRadius: "50%",
    border: "2px solid #000",
    outline: "1px solid rgba(255,255,255,0.75)",
    background: "rgba(180,180,180,0.32)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    userSelect: "none",
    backdropFilter: "blur(2px)",
    WebkitBackdropFilter: "blur(2px)",
    boxShadow: "0 0 0 1.5px #000",
  };

  const iconStyle = {
    width: 17,
    height: 17,
    stroke: "#ffffff",
    strokeWidth:4.5,
    fill: "none",
  };

  const label = {
    color: "#fff",
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "DM Sans,sans-serif",
  };

  const handleShare = async (e) => {
    e.stopPropagation();

    setIsShared(true);

    setTimeout(() => setIsShared(false), 1500);

    try {
      if (navigator.share) {
        await navigator.share({
          title: "IcingShow",
          url: window.location.href,
        });
      } else {
        await navigator.clipboard.writeText(window.location.href);
      }

      await videoAPI.shareVideo(video.id, "general");
    } catch (err) {}
  };

  const handleSave = async (e) => {
    e.stopPropagation();

    setIsSaved(prev => !prev);

    try {
      await favoriteAPI.favoriteVideo(video.id);
    } catch (err) {}
  };

  return (
    <>
      {/* LIKE */}
      <div style={wrapper}>
        <button
          onClick={(e) => {
            e.stopPropagation();

            if (onLike) onLike(e);
          }}
          style={buttonStyle}
        >
          <svg viewBox="0 0 24 24" style={iconStyle}>
            <path d="M12 21s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 11c0 5.65-7 10-7 10z" fill={isLiked ? "#ffffff" : "none"} />
          </svg>
        </button>

        <span style={label}>{fmt(likes)}</span>
      </div>

      {/* COMMENT */}
      <div style={wrapper}>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            if (onComment) onComment(e);
          }}
          style={buttonStyle}
        >
          <svg viewBox="0 0 24 24" style={iconStyle}>
            <path d="M4 5h16v10H8l-4 4V5z" />
          </svg>
        </button>

        <span style={label}>
          {fmt(commentCount !== undefined ? commentCount : video.comments_count || 0)}
        </span>
      </div>

      {/* SHARE */}
      <div style={wrapper}>
        <button
          onClick={handleShare}
          style={buttonStyle}
        >
          <svg viewBox="0 0 24 24" style={iconStyle}>
            <path d="M8 12h8" />
            <path d="M13 7l5 5-5 5" />
          </svg>
        </button>

        <span style={label}>
          {fmt(video.shares || 0)}
        </span>
      </div>

      {/* SAVE */}
      <div style={wrapper}>
        <button
          onClick={handleSave}
          style={buttonStyle}
        >
          <svg viewBox="0 0 24 24" style={iconStyle}>
            <path d="M6 3h12v18l-6-4-6 4V3z" fill={isSaved ? "#ffffff" : "none"} />
          </svg>
        </button>

        <span style={label}>
          Save
        </span>
      </div>

      {/* GIFT */}
      <div style={wrapper}>
        <button
          onClick={async (e) => {
            e.stopPropagation();

            const amt = prompt(
              "Gift IcingPoints to " +
              (video.creator?.username || "creator") +
              ":\nEnter amount:"
            );

            if (!amt || isNaN(amt) || Number(amt) <= 0) return;

            try {
              await api.post("/gifts/send/", {
                creator_id: video.creator.id,
                amount: Number(amt),
                video_id: video.id,
              });

              alert("Gifted " + amt + " IcingPoints!");
            } catch (err) {
              alert("Gift failed. Check your balance.");
            }
          }}
          style={{
            ...buttonStyle,
            border: "1px solid rgba(230,199,106,0.7)",
            color: "#E6C76A",
          }}
        >
          <span
            style={{
              color: "#E6C76A",
              fontStyle: "italic",
              fontWeight: 900,
              fontSize: 24,
              fontFamily: "Georgia,serif",
            }}
          >
            I
          </span>
        </button>

        <span
          style={{
            ...label,
            color: "#E6C76A",
          }}
        >
          Gift
        </span>
      </div>
    </>
  );
}

export default ActionButtons;
